import PageHeader from "../components/UI/PageHeader";
import ChannelPreferance from "../components/section/ChannelPreferance";

const TelegramAlertSettings = () => {
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <PageHeader title="Alert Settings" />
      <div className="w-full max-w-[600px] mx-auto px-4 py-6">
        <p className="px-1 mb-2 text-xs font-semibold tracking-wider uppercase text-gray-400">
          Notification Channels
        </p>
        <ChannelPreferance />
        <p className="px-1 mt-3 text-xs text-gray-400">
          Choose how you'd like to receive tender alerts.
        </p>
      </div>
    </div>
  );
};

export default TelegramAlertSettings;
